// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceDisplayDiscount_price__1vo1i","fakePrice":"PriceDisplayDiscount_fakePrice__WwPoV","discount":"PriceDisplayDiscount_discount__yIAtJ"};